'use client';

import type {SideMenuUserOptionsProps as Props} from './typings';

import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import constantsFactory from '@/utils/constants';
import {emit} from '@/utils/events';
import {
  StyledNavigationButton,
  StyledSideMenuList,
  StyledSideMenuListItem,
  StyledUserSigninOptions,
} from './styles';

const {ROLES} = constantsFactory();

const SideMenuUserOptions = ({auth, handleCloseSideMenu, isActive}: Props): JSX.Element => {
  const isAuthenticated = auth.isAuthenticated();
  const isAdmin = isAuthenticated && auth.isAuthorised([ROLES.STAFF]);
  const isProvider = isAuthenticated && auth.isAuthorised([ROLES.PROVIDER]);

  if (!isAuthenticated) {
    return (
      <StyledUserSigninOptions>
        <CtaButton
          style="secondary"
          onClick={() => {
            handleCloseSideMenu();
            emit('CLICK_ON_LOGIN');
          }}
          tabIndex={isActive ? 0 : -1}
        >
          Log in
        </CtaButton>

        <CtaButton
          style="tertiary"
          onClick={() => {
            handleCloseSideMenu();
            emit('CLICK_ON_JOIN');
          }}
          tabIndex={isActive ? 0 : -1}
        >
          Sign up
        </CtaButton>
      </StyledUserSigninOptions>
    );
  }
  return (
    <StyledSideMenuList title={isAdmin ? 'Management' : 'Account'}>
      {isAdmin && (
        <StyledSideMenuListItem $isSubMenu>
          <a href="/dashboard/" tabIndex={isActive ? 0 : -1} onClick={handleCloseSideMenu}>
            Dashboard
          </a>
        </StyledSideMenuListItem>
      )}
      {isProvider && (
        <StyledSideMenuListItem $isSubMenu>
          <a href="/manage/" tabIndex={isActive ? 0 : -1} onClick={handleCloseSideMenu}>
            Manage my shop
          </a>
        </StyledSideMenuListItem>
      )}
      <StyledSideMenuListItem>
        <StyledNavigationButton
          aria-label="Log out"
          tabIndex={isActive ? 0 : -1}
          onClick={() => {
            handleCloseSideMenu();
            auth.logout();
          }}
        >
          Log out
        </StyledNavigationButton>
      </StyledSideMenuListItem>
    </StyledSideMenuList>
  );
};

export default SideMenuUserOptions;
